import React, { useEffect, useState } from 'react';
import Modal from 'react-responsive-modal';
import {
	Form,
	FormGroup,
	Col,
} from 'reactstrap';
import { Post } from '../../../../function/Koneksi';

import { CKEditor } from '@ckeditor/ckeditor5-react';
import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document/';

const ModalProfil = ({ data, setAlert, isOpen, setIsOpen, statusRefresh, setStatusRefresh, propsData }) => {

	const initFormData = {
		status: {
			form: false,
			btnForm: false,
			btnAksi: [],
		},
		show: false,
		basicTitle: "",
		basicType: "default",
		pesanAlert: "",
	}

	const [formData, setFormData] = useState(initFormData)
	const [dt, setDt] = useState(data)


	useEffect(() => {
		if (document.getElementById("modalForm")) {
			document.getElementById("modalForm").reset()
		}
		
		if(data.profil){
			setDt({
				...dt,
				uuid: data.uuid,
				nama_lembaga: data.nama_lembaga,
				tahun_berdiri: data.tahun_berdiri,
				profil: data.profil,
			})
		}
		else{
			setDt({
				...dt,
				uuid: data.uuid,
				nama_lembaga: data.nama_lembaga,
				tahun_berdiri: data.tahun_berdiri,
				profil: '',
			})
		}
		setFormData(data ? {
			...initFormData,
		} : initFormData)
	}, [isOpen, data])

	const simpan = (e) => {
		e.preventDefault();
		let bodyRaw = {
			...dt,
			uuid : document.getElementById("uuid").value,
			nama_lembaga : dt.nama_lembaga,
			tahun_berdiri : dt.tahun_berdiri,
			profil : dt.profil,
		}

		let psn = "";
		let resstat = 204;
		let metode = "create";
		if (bodyRaw.uuid === "") {
			psn = "Tambah";
			resstat = 201;
			bodyRaw.uuid = null;
		} else {
			psn = "Ubah";
			resstat = 200;
			metode = "update";
		}
			
		Post("lembaga-kemasyarakatan/" + metode, bodyRaw.uuid, bodyRaw,res => {
			setFormData({
				...formData,
				status: {
					...formData.status,
					btnForm: false,
					form: false,
				}
			})
			setIsOpen(false)
			if (res.status === resstat) {
				const alertData = {
					show: true,
					basicType: "success",
					basicTitle: "Data Profil Lembaga",
					pesanAlert: "Berhasil " + psn + " Data",
					successAlert: true,
				}
				setAlert(alertData)
			} else {
				const alertData = {
					show: true,
					basicType: "danger",
					basicTitle: "Data Profil Lembaga",
					pesanAlert: "Gagal " + psn + " Data"
				}
				setAlert(alertData)
			}

			// Refresh list
			setStatusRefresh(true)
		});
	};

	return (
		<Modal
			classNames={{ overlay: 'card-scrollable' }}
			open={isOpen}
			onClose={() => {
				setIsOpen(false)
			}}
			closeOnEsc={false}
			closeOnOverlayClick={false}
			styles={{ modal: { width: '100%', maxWidth: 'unset' } }}
		>
			<Form
				id="modalForm"
				data-testid="form-create"
				className="theme-form"
				onSubmit={simpan} 
			>
				<div className="modal-header">
					<h5 className="modal-title">{dt.uuid == '' ? 'Tambah' : 'Edit'} Profil {dt.nama_lembaga}</h5>
				</div>
				<div className="modal-body">
					<input
						className="form-control"
						id="uuid"
						type="hidden"
						placeholder=""
						defaultValue={dt.uuid}
					/>
					<FormGroup className="row">
						<Col sm='12'>
							<CKEditor
								onReady={editor => {
								// Insert the toolbar before the editable area.
								editor.ui.getEditableElement().parentElement.insertBefore(
									editor.ui.view.toolbar.element,
									editor.ui.getEditableElement()
								);

									// this.editor = editor;
								}}
								onError={(error, { willEditorRestart }) => {
								if (willEditorRestart) {
									this.editor.ui.view.toolbar.element.remove();
								}
								}}
								onChange={(event, editor) => {
									const data = editor.getData();
									setDt({
										...dt,
										profil: data,
									})
								}}
								editor={DecoupledEditor}
								data={dt.profil}
								config={{         
								toolbar: ['heading', '|', 'bold', 'italic', 'blockQuote', 'link', 'numberedList', 'bulletedList', '|', 'undo', 'redo']
								}}
							/>
						</Col>
					</FormGroup>
				</div>
				<div className="modal-footer">
					<button
						type="button"
						className="btn btn-warning"
						onClick={() => {
							setIsOpen(false)
						}}
					>
						Tutup
					</button>
					<button
						data-testid="btnSubmitCreate"
						type="submit"
						className="btn btn-primary-custom"
						disabled={formData.status && formData.status.btnForm}
					>
						Simpan
					</button>
				</div>
			</Form>
		</Modal>
	);
}

export default ModalProfil;
